import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputLabel } from "@mui/material";
import React, { useRef } from "react";

const CompanyAddBreachAwareModal = (props) => {

	const email = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleYes = () => {
		const breachAwareRequest = {
			enabled: 1,
			companyId: props.company.id
		};
		props.onSubmit(breachAwareRequest);
	};
	
	const handleNo = () => {
		const breachAwareRequest = {
			enabled: 0,
			companyId: props.company.id
		};
		props.onSubmit(breachAwareRequest);
	};
	
	const handleCancel = () => {
		props.onClose();
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em 10%"
	};
	
	return (
		<Dialog
			open={props.company}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Enable Dark Web Monitoring for {props.company? props.company.name : ""}?
			</DialogTitle>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleNo} autoFocus>No</Button>
				<Button onClick={handleYes} autoFocus>Yes</Button>
			</DialogActions>
		</Dialog>
	);

}

export default CompanyAddBreachAwareModal;